exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/ibo/ibo-logs/ibo-logs.component.css
// module id = ../../../../../src/app/components/pages/ibo/ibo-logs/ibo-logs.component.css
// module chunks = main